import * as React from 'react';
import { inject } from 'mobx-react';

import { Layer } from 'bernie-view';
import { AnalyticsStore, RouteStore, ContextStore } from 'bernie-core';

import { FORCED_CHOICE_DIALOG_ID, StaleSessionDialog } from '.';
import { ListingsStore, SearchCriteriaStore, SortFilterStore } from 'stores';
import { AnalyticsType } from 'types/shared';
import { DialogStaleSession } from 'types/search/dialogs';
import { trackAnalytics } from 'utility';

interface StaleSessionProps {
  staleSession: DialogStaleSession;
  routeStore?: RouteStore;
  searchCriteriaStore?: SearchCriteriaStore;
  analytics?: AnalyticsStore;
  context?: ContextStore;
  listingsStore?: ListingsStore;
  sortFilterStore?: SortFilterStore;
}

interface StaleSessionState {
  isDialogVisible: boolean;
}

@inject('routeStore', 'searchCriteriaStore', 'analytics', 'context', 'listingsStore', 'sortFilterStore')
export class StaleSession extends React.Component<StaleSessionProps, StaleSessionState> {
  public constructor(props) {
    super(props);

    this.state = {
      isDialogVisible: false
    };
  }

  private dialogId = 'stale-session';
  private timerId: ReturnType<typeof setTimeout>;

  public componentDidMount = () => {
    this.startTimer();
  };

  componentWillUnmount = () => {
    clearTimeout(this.timerId);
  };

  public startTimer = () => {
    const { staleSession } = this.props;
    const timeoutInMilliseconds = staleSession.timeoutInSeconds * 1000;

    this.timerId = setTimeout(this.openDialog, timeoutInMilliseconds);
  };

  private openDialog = () => {
    const { analytics, staleSession, routeStore, listingsStore } = this.props;
    const analyticsType: AnalyticsType = staleSession && staleSession.displayedAnalytics;

    if (routeStore.search.includes(FORCED_CHOICE_DIALOG_ID)) {
      routeStore.closeDialog(FORCED_CHOICE_DIALOG_ID);
    }
    this.setState({
      isDialogVisible: true
    });

    listingsStore.trackOnViewedAnalytics(analytics);
    trackAnalytics(analyticsType, analytics);
  };

  private refreshSearch = () => {
    const { routeStore, staleSession, analytics, searchCriteriaStore, context, sortFilterStore } = this.props;
    const analyticsType: AnalyticsType =
      staleSession && staleSession.actions.find(action => action.analytics).analytics;

    searchCriteriaStore.syncWithSortAndFilterStore(sortFilterStore);
    trackAnalytics(analyticsType, analytics);
    searchCriteriaStore.triggerSearch(routeStore, context, true, true);
    analytics.resetAnalyticsForNewPage();
  };

  public render() {
    const { isDialogVisible } = this.state;

    if (!isDialogVisible) {
      return null;
    }

    return (
      <Layer id={`${this.dialogId}-dialog`}>
        <StaleSessionDialog dialogId={this.dialogId} refreshSearch={this.refreshSearch} {...this.props.staleSession} />
      </Layer>
    );
  }
}
